import { api } from '@here/api'

/**
 * Deletes a setup by its ID.
 * @param {string} id - The ID of the setup to delete.
 * @returns {Object|null} The deleted setup data, or null if deletion fails.
 */
export const getCurrentSetupChannel = async (id: string) => {
	const { data, error } = await api()
		.from('channel')
		.select('*')
		.eq('name', id)
		.maybeSingle()

	if (error) {
		console.error(error)
		throw new Error(error.message)
	}

	return data
}
